



























































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import JobList from "@/components/JobList.vue";
import DonutChart from "@/components/Charts/DonutChart.vue";
import { Job } from "@/models/job.model";
import { CardModel, CardUserModel } from "@/models/card.model";
import { AssignedJob } from "@/models/assignedJob.model";
import { JobCommand,Action } from "@/models/app.model";
import store from "../store/store";
import { Setting } from "@/models/setting.model";
import Pill from "@/components/Pill.vue";
import { mapGetters } from "vuex";

@Component({
    computed: mapGetters({
        allowCardPinBoardLocking: "auth/cardPinBoardLocking",
    }),
    components: {
        JobList,
        DonutChart,
        Pill,
    },
})
export default class CardCard extends Vue {
    @Prop() private card!: CardModel;
    jobs: AssignedJob[] = [];
    jobdatafromStore: AssignedJob[] = [];

    action = Action;

    // test: any = [];

    moved(obj: any) {
        // console.log(obj);
    }

    checkMove(obj: any) {
        // console.log(obj);
    }

    getDraggableOptions() {
        return { group: "carduser", handle: ".handle" };
    }

    setCurrentCard(cardId: number) {
        if (this.$route.params.cardid != undefined) {
            this.$router.replace({
                name: "currentPinboard",
                params: { pinBoardId: this.$route.params.pinBoardId },
            });
        } else {
            this.$router.replace({
                name: "currentCard",
                params: {
                    pinBoardId: this.$route.params.pinBoardId,
                    cardid: cardId.toString(),
                },
            });
        }
    }

    get jobCount() {
        return this.cardJobs.length;
    }

    get jobDoneCount() {
        return this.cardJobs.filter((j) => j.done).length;
    }

    get jobRemainingCount() {
        return this.cardJobs.filter((j) => !j.done).length;
    }

    get setting() {
        return this.$store.getters["app/setting"];
    }

    get cardJobs() {
        return this.$store.getters["job/currentJobsByCardId"](
            this.card.id
        ) as AssignedJob[];
    }

    get cardUsers() {
        return this.$store.getters["card/getCardUsersOnPinBoardByCardId"](
            this.card.id
        ) as CardUserModel[];
    }

    get allCardUsers() {
        return this.$store.getters[
            "card/getCardUsersOnPinBoard"
        ] as CardUserModel[];
    }

    set cardUsers(cardUsersList: CardUserModel[]) {
        if (cardUsersList.length > 0 && cardUsersList) {
            if (cardUsersList.some((j) => j.cardId != this.card.id)) {
                // console.log(this.allCardUsers);
                this.$store
                    .dispatch("card/moveCardUser", {
                        id: cardUsersList.find((j) => j.cardId != this.card.id)!
                            .id,
                        newCardId: this.card.id,
                        cardUserId: cardUsersList.find(
                            (j) => j.cardId != this.card.id
                        )!.cardUserId,
                    })
                    .then((result) => console.log(result));
            }
        }
    }

    @Watch("card.isAvailable")
    async cardAvailabilityChanged() {
        this.$store.dispatch("card/setCardAvailability", this.card);
    }

    async toolTipMessage() {
        if (
            this.jobCount >= 6 &&
            this.jobDoneCount == 0 &&
            this.setting!.showMuchNowText
        )
            return this.setting!.muchNowText;
        if (
            this.jobCount == 0 &&
            this.card!.isAvailable &&
            this.setting!.showNothingToDoText
        )
            return this.setting!.nothingToDoText;
        if (
            this.jobCount == this.jobDoneCount &&
            this.jobCount != 0 &&
            this.setting!.showDoneText
        )
            return this.setting!.doneText;
        return "";
    }
}
